import { Tooltip } from "primereact/tooltip";
import "./style.scss";

const TooltipUI = (props) => <Tooltip {...props} className={`tooltip-ui ${props.className}`} />;

export default TooltipUI;
